import { IconAvatar } from '@ds/icons/IconAvatar'
import { IconFactory } from '@ds/icons/IconFactory'
import { IconListView2 } from '@ds/icons/IconListView2'
import { IconMail } from '@ds/icons/IconMail'

export const PROFILES = {
  BUSINESS_DETAILS: 'business-details',
  LEGAL_DETAILS: 'legal-detail',
  CONTACT_DETAILS: 'contact-details',
  USER_PERMISSIONS: 'user-permissions',
}

export const PROFILE_ICONS = {
  [PROFILES.BUSINESS_DETAILS]: IconFactory,
  [PROFILES.LEGAL_DETAILS]: IconListView2,
  [PROFILES.CONTACT_DETAILS]: IconMail,
  [PROFILES.USER_PERMISSIONS]: IconAvatar,
}

export const MODAL_NAMES = {
  EDIT_BUSINESS_DETAILS: 'EDIT_BUSINESS_DETAILS',
  EDIT_LEGAL_DETAILS: 'EDIT_LEGAL_DETAILS',
  EDIT_TAX_DETAILS: 'EDIT_TAX_DETAILS',
  EDIT_EPR_DETAILS: 'EDIT_EPR_DETAILS',
  EDIT_TAX_MAIN_RESIDENCE_COUNTRY: 'EDIT_TAX_MAIN_RESIDENCE_COUNTRY',
  EDIT_TAX_ADDITIONAL_RESIDENCE_COUNTRIES:
    'EDIT_TAX_ADDITIONAL_RESIDENCE_COUNTRIES',
  DELETE_EPR_DETAIL: 'DELETE_EPR_DETAIL',
  USER_PERMISSIONS: {
    ACTIVATE_OR_DEACTIVATE_USER: 'ACTIVATE_OR_DEACTIVATE_USER',
    USER_FORM: 'USER_FORM',
  },
  EDIT_TAX_IDENTIFICATION_NUMBER: 'EDIT_TAX_IDENTIFICATION_NUMBER',
}

// TODO is it useful?
export const FORM_IDS = {
  EDIT_BUSINESS_DETAILS: 'edit_business_details_form',
  EDIT_LEGAL_DETAILS: {
    default: 'edit_legal_details_default_form',
    japan: 'edit_legal_details_japan_form',
    australia: 'edit_legal_details_australia_form',
  },
  EDIT_TAX_DETAILS: 'edit_tax_details_form',
  EDIT_EPR_DETAILS: 'epr_details_form',
  EDIT_LEGAL_DOCUMENTS: 'edit_legal_documents_form',
  // TODO not used
  USER_PERMISSIONS: {
    EDIT_FORM: 'user_permission_edit_form',
  },
}
